import React from "react";
import "./CustomLoader.css";

function CustomLoader() {
  return <span className="loader"></span>;
}

export default CustomLoader;
